const translations = {
  apartments: 'Квартиры',
  rooms: 'Комнаты',
  'new-buildings': 'Новостройки',
  houses: 'Дома',
  'land-plots': 'Участки',
  garages: 'Гаражи',
  storages: 'Склады',
  offices: 'Офисы',
  'retail-spaces': 'Торговые помещения',
  'industrial-spaces': 'Производственные помещения',
  'free-spaces': 'Помещения свободного назначения',
  'gotoviy-bizness': 'Готовый бизнес',
  'uchastok-kommercheskiy': 'Участок коммерческий',
  obschepit: 'Общепит',
  gostinica: 'Гостиница',
  'avtoservice-avtomoika': 'Автосервис / Автомойка',
  'real-estate': 'Недвижимость',
};

export const t = (key: string) =>
  translations[key as keyof typeof translations];
